module.exports = __webpack_public_path__ + "static/media/the-curse-of-la-llorona.cad2fb46.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/backdrops/the-curse-of-la-llorona.jpg
// module id = 284
// module chunks = 0